// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"ra_a big_sw big_kx big_ky","PostDetailRight__brandDaysPosts":"ra_b big_sw big_kx big_ky"};